import { API } from "../config"

export const createCategory = async (userId, token, category) => {
    try {
        const response = await fetch(`${API}/category/create/${userId}`, {
            method: "POST",
            headers: {
                Accept: 'application/json',
                "Content-Type": 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(category)
        })
        return await response.json()
    } catch (err) {
        console.log(err)
    }
}

export const createProduct = async (userId, token, product) => {
    try {
        const response = await fetch(`${API}/product/create/${userId}`, {
            method: "POST",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: product
        })
        return await response.json()
    } catch (err) {
        console.log(err)
    }
}

export const getCategories = async () => {
    try {
        const response = await fetch(`${API}/categories`, {
            method: "GET",
        })
        return response.json()
    } catch (err) {
        console.log(err)
    }
}